import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./Layout.css";
import HangtenBearSupport from "./HangtenBearSupport";

function MenuLink({ to, children }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        "erp__link" + (isActive ? " is-active" : "")
      }
    >
      {children}
    </NavLink>
  );
}

function MenuGroup({ title, children }) {
  return (
    <div className="erp__group">
      <div className="erp__groupTitle">{title}</div>
      <div className="erp__groupLinks">{children}</div>
    </div>
  );
}

export default function Layout({ title, children }) {
  const {pathname}=useLocation();
  const cancelledPage=pathname==='/erp/cancelled-vouchers';
  const [cancelMenu,setCancelMenu]=useState(false);
  const inventory=pathname==='/erp/inventory'||pathname.startsWith('/erp/inventory/');
  const [expanded,setExpanded]=useState(()=>sessionStorage.getItem('inventoryFocus')==='true');
  const [filters,setFilters]=useState(false);
  const focus=inventory&&expanded;
  function toggleFocus(value){setExpanded(value);sessionStorage.setItem('inventoryFocus',String(value));}
  useEffect(()=>{if(!focus)return;const previous=document.body.style.overflow;document.body.style.overflow='hidden';
    const escape=e=>{if(e.key==='Escape'){setExpanded(false);sessionStorage.setItem('inventoryFocus','false');}};
    window.addEventListener('keydown',escape);return ()=>{document.body.style.overflow=previous;window.removeEventListener('keydown',escape);};
  },[focus]);
  useEffect(()=>setFilters(false),[pathname]);
  const inventoryLinks=[['/erp/inventory','Shop Cards'],['/erp/inventory/survey','Survey'],['/erp/inventory/stock-balance','Stock Balance'],['/erp/inventory/negative','Negative Stock'],['/erp/inventory/low-stock','Low Stock'],['/erp/inventory/tools','Inventory Tools']];

  return (
    <div className={"erp"+(cancelledPage?" erp--cancelled":"")+(cancelMenu?" erp--cancelMenu":"")+(focus?" erp--inventoryFocus":"")+(filters?" erp--showInventoryFilters":"")}>
      {cancelledPage && <button type="button" className="cv-mobile-menu" aria-expanded={cancelMenu} aria-controls="cv-erp-sidebar" onClick={()=>setCancelMenu(value=>!value)}><span>Retail ERP</span><span>{cancelMenu?'Close menu ×':'ERP menu ☰'}</span></button>}
      <aside className="erp__sidebar" id={cancelledPage?'cv-erp-sidebar':undefined}>
        <div className="erp__brandBox">
          <div className="erp__brandMark">E</div>
          <div>
            <div className="erp__brand">Retail ERP</div>
            <div className="erp__brandSub">Clean Office Dashboard</div>
          </div>
        </div>

        <nav className="erp__nav">
          <MenuGroup title="Main">
            <MenuLink to="/erp/dashboard">Dashboard</MenuLink>
          </MenuGroup>

          <MenuGroup title="Sales & Operation">
            <MenuLink to="/erp/all-shop-sales">All Shop Sales</MenuLink>
            <MenuLink to="/erp/cancelled-vouchers">Cancelled Vouchers</MenuLink>
            <MenuLink to="/erp/inventory">Inventory</MenuLink>
            <MenuLink to="/erp/inventory-catalog">All Shop Inventory</MenuLink>
            <MenuLink to="/erp/locations">Locations</MenuLink>
            <MenuLink to="/erp/warehouse">Warehouse</MenuLink>
          </MenuGroup>

          <MenuGroup title="Fulfillment">
            <MenuLink to="/erp/waybill">Waybill Monitor</MenuLink>
          </MenuGroup>

          <MenuGroup title="Promotion & Coupon">
            <MenuLink to="/erp/promotions">Promotions</MenuLink>
            <MenuLink to="/erp/coupons">Coupons</MenuLink>
            <MenuLink to="/erp/members">Members</MenuLink>
            <MenuLink to="/erp/promotion-history">Gift History</MenuLink>
            <MenuLink to="/erp/promotion-discount-history">
              Discount History
            </MenuLink>
          </MenuGroup>

          <MenuGroup title="Delivery & Notice">
            <MenuLink to="/erp/delivery-rates">Delivery Rates</MenuLink>
            <MenuLink to="/erp/delivery-marketing">
              Delivery Marketing
            </MenuLink>
            <MenuLink to="/erp/delivery-free-rules">
              Free Delivery Rules
            </MenuLink>
            <MenuLink to="/erp/notice-warning">Notice / Warning</MenuLink>
          </MenuGroup>
        </nav>

        <div className="erp__hint">
          <strong>Admin Panel</strong>
          <span>White / Grey / Soft Blue</span>
        </div>
      </aside>

      <main className="erp__main">
        <header className="erp__topbar">
          <div>
            <div className="erp__title">{title}</div>
            <div className="erp__breadcrumb">ERP / {title}</div>
          </div>

          <div className="erp__topbarRight">
            <input className="erp__search" placeholder="Search ERP..." />
            <div className="erp__avatar">A</div>
          </div>
        </header>

        {inventory&&<div className="inventoryFocusBar">
          {focus&&<nav aria-label="Full screen inventory navigation">{inventoryLinks.map(([to,label])=><NavLink key={to} to={to} end>{label}</NavLink>)}</nav>}
          <div className="inventoryFocusActions">{focus&&<button onClick={()=>setFilters(v=>!v)} aria-pressed={filters}>{filters?'Hide filters':'Search / Filters'}</button>}
          <button onClick={()=>toggleFocus(!focus)}>{focus?'Exit full screen':'Full Screen'}</button></div>
        </div>}
        <section className="erp__content">{children}</section>
        <HangtenBearSupport />
      </main>
    </div>
  );
}




